export const FIRMWARE_VERSION_OPTIONS: { label: string, value: string }[] = [
    { label: 'v1', value: 'v1.0.0' },
    { label: 'v2', value: 'v2.0.0' },
    { label: 'v3', value: 'v3.0.0' }
];
